import { Checkbox } from 'antd'
import type { ColumnType } from 'antd/es/table'

import type { ReceivedCancellationRequestRoot } from '@repo/sdk'

export interface CheckboxColumnProps {
  selectedIds: string[]
  onToggle: (cancellationId: string) => void
}

export function createCheckboxColumn({
  selectedIds,
  onToggle,
}: CheckboxColumnProps): ColumnType<ReceivedCancellationRequestRoot> {
  return {
    title: '',
    key: 'checkbox',
    width: 50,
    render: (_: unknown, record: ReceivedCancellationRequestRoot) => (
      <Checkbox
        data-testid={`cancellation-list-checkbox-${record.cancellationId}`}
        checked={selectedIds.includes(record.cancellationId)}
        onClick={(e) => e.stopPropagation()}
        onChange={() => onToggle(record.cancellationId)}
      />
    ),
  }
}
